import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const useBlogPosts = (params = {}) => {
  return useQuery({
    queryKey: ['blogPosts', params],
    queryFn: async () => {
      const response = await api.get('/blog-posts', { params });
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useBlogPost = (slug) => {
  return useQuery({
    queryKey: ['blogPost', slug],
    queryFn: async () => {
      if (!slug) return null;
      const response = await api.get(`/blog-posts/${slug}`);
      return response.data;
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

